import React, { useState } from "react"

import { IconSimpleArrowDownMedium, IconSimpleArrowUpMedium } from "@izettle/otto"

import { Item, TabButton } from "./styles"

export const Accordion: React.FC<{ title: string }> = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleAccordion = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Item>
      <TabButton
        role="tab"
        type="button"
        onClick={toggleAccordion}
        aria-expanded={isExpanded}
        svgIcon={isExpanded ? IconSimpleArrowUpMedium : IconSimpleArrowDownMedium}
      >
        {title}
      </TabButton>
      <div
        role="tabpanel"
        aria-hidden={!isExpanded}
        style={{ display: isExpanded ? "block" : "none" }}
      >
        {children}
      </div>
    </Item>
  )
}
